import {clsx} from 'clsx'
import {use, useEffect} from 'react'
import {getNodeText} from '../shared'
import ChartCardContext from './context'

import styles from './Description.module.css'

export type DescriptionProps = {
  children: React.ReactNode
  className?: string
}

const Description = ({children, className}: DescriptionProps) => {
  const {setDescription, size} = use(ChartCardContext)
  useEffect(() => {
    setDescription(getNodeText(children))
  }, [setDescription, children])
  return size !== 'sparkline' ? (
    <span className={clsx(styles.ChartCardDescriptionText, className)}>{children}</span>
  ) : null
}

export default Description
